var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid grid-cols-1",staticStyle:{"min-height":"calc(100vh - 72px)"}},[_c('order-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }